import styled from 'styled-components'

export const FeaturePromotionModalImage = styled.img`
  display: block;
  width: 100%;

  aspect-ratio: 16/9;

  border-radius: ${(props) => props.theme.typography.pxToRem(8)};

  object-fit: cover;
`
